<app-page-breadcrumb [pageTitle]="isEdit ? 'Editar Usuario' : 'Nuevo Usuario'"></app-page-breadcrumb>

<div class="grid grid-cols-1 gap-6">
  <app-component-card
    [title]="isEdit ? 'Editar Usuario' : 'Nuevo Usuario'"
    desc="Completa la información del usuario">

    <!--
      El componente ya venía calculando `error` (409 correo duplicado, 403 rol superior, sin
      permisos…) pero no lo pintaba en ninguna parte: el toast dura 4 s y el usuario se quedaba
      sin referencia mientras corregía.
    -->
    @if (error) {
      <div class="mb-5 rounded-lg border border-error-200 bg-error-50 px-4 py-3 text-sm text-error-700
                  dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
        {{ error }}
      </div>
    }

    @if (!loading) {
      <form [formGroup]="form" (ngSubmit)="save()" class="space-y-7">

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            Nombres *
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 left-3 flex items-center text-gray-400">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>

            <input
              type="text"
              formControlName="fullname"
              placeholder="Ej: Juan"
              class="pl-10 pr-10 h-11 w-full rounded-lg border bg-white text-gray-800
                     dark:bg-gray-900 dark:border-gray-700 dark:text-white
                     focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 transition"
              [ngClass]="{
                'border-error-500': hasError('fullname'),
                'border-green-500': isValidField('fullname')
              }"
            />

            @if (isValidField('fullname')) {
              <span class="absolute inset-y-0 right-3 flex items-center text-green-500">
                ✔
              </span>
            }
          </div>

          @if (hasError('fullname')) {
            <p class="text-error-500 text-sm mt-1">{{ getError('fullname') }}</p>
          }
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            Apellidos *
          </label>

          <div class="relative">
            <div class="absolute inset-y-0 left-3 flex items-center text-gray-400">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <rect x="2" y="6" width="20" height="12" rx="2"/>
                <path d="M6 10h4M6 14h2"/>
              </svg>
            </div>

            <input
              type="text"
              formControlName="lastname"
              placeholder="Ej: Pérez"
              class="pl-10 pr-10 h-11 w-full rounded-lg border bg-white text-gray-800
                     dark:bg-gray-900 dark:border-gray-700 dark:text-white
                     focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 transition"
              [ngClass]="{
                'border-error-500': hasError('lastname'),
                'border-green-500': isValidField('lastname')
              }"
            />

            @if (isValidField('lastname')) {
              <span class="absolute inset-y-0 right-3 flex items-center text-green-500">
                ✔
              </span>
            }
          </div>

          @if (hasError('lastname')) {
            <p class="text-error-500 text-sm mt-1">{{ getError('lastname') }}</p>
          }
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            Correo electrónico *
          </label>

          <div class="relative">
            <div class="absolute inset-y-0 left-3 flex items-center text-gray-400">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M4 4h16v16H4z"/>
                <path d="M22 6l-10 7L2 6"/>
              </svg>
            </div>

            <input
              type="email"
              formControlName="mail"
              placeholder="correo@empresa.com"
              class="pl-10 pr-10 h-11 w-full rounded-lg border bg-white text-gray-800
                     dark:bg-gray-900 dark:border-gray-700 dark:text-white
                     focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 transition"
              [ngClass]="{
                'border-error-500': hasError('mail'),
                'border-green-500': isValidField('mail')
              }"
            />

            @if (isValidField('mail')) {
              <span class="absolute inset-y-0 right-3 flex items-center text-green-500">
                ✔
              </span>
            }
          </div>

          @if (hasError('mail')) {
            <p class="text-error-500 text-sm mt-1">{{ getError('mail') }}</p>
          }
        </div>

        @if (!isEdit) {
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
              Contraseña *
            </label>

            <div class="relative">
              <div class="absolute inset-y-0 left-3 flex items-center text-gray-400">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <rect x="3" y="11" width="18" height="10" rx="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4"/>
                </svg>
              </div>

              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="Mínimo 8 caracteres, con mayúscula, minúscula, número y carácter especial"
                class="pl-10 pr-12 h-11 w-full rounded-lg border bg-white text-gray-800
                       dark:bg-gray-900 dark:border-gray-700 dark:text-white
                       focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 transition"
                [ngClass]="{
                  'border-error-500': hasError('password'),
                  'border-green-500': isValidField('password')
                }"
              />

              <button
                type="button"
                (click)="showPassword = !showPassword"
                class="absolute inset-y-0 right-0 px-3 flex items-center justify-center text-gray-400 hover:text-brand-500 transition">

                <svg *ngIf="!showPassword"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke-width="1.8"
                     stroke="currentColor"
                     class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5
                       c4.477 0 8.268 2.943 9.542 7
                       -1.274 4.057-5.065 7-9.542 7
                       -4.477 0-8.268-2.943-9.542-7z"/>
                </svg>

                <svg *ngIf="showPassword"
                     xmlns="http://www.w3.org/2000/svg"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke-width="1.8"
                     stroke="currentColor"
                     class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M3 3l18 18"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M10.58 10.58A3 3 0 0012 15a3 3 0 002.42-4.42M6.1 6.1
                       A9.956 9.956 0 012.25 12
                       c1.274 4.057 5.065 7 9.542 7
                       1.3 0 2.52-.22 3.65-.63M9.88 4.24
                       A9.77 9.77 0 0112 5
                       c4.477 0 8.268 2.943 9.542 7
                       a9.97 9.97 0 01-4.293 5.098"/>
                </svg>

              </button>
            </div>

            @if (hasError('password')) {
              <p class="text-error-500 text-sm mt-1">{{ getError('password') }}</p>
            }
          </div>
        }

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            Rol *
          </label>

          <select
            formControlName="idRol"
            class="h-11 w-full rounded-lg border bg-white text-gray-800
                   dark:bg-gray-900 dark:border-gray-700 dark:text-white
                   focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 transition"
            [ngClass]="{
              'border-error-500': hasError('idRol'),
              'border-green-500': isValidField('idRol')
            }"
          >
            @for (r of allRoles; track r.id) {
              <option [ngValue]="r.id" [disabled]="roleDisabled(r.id)">
                {{ r.name }}
              </option>
            }
          </select>

          <div class="mt-3">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium
                         bg-brand-500/10 text-brand-600 dark:text-brand-400">
              {{ selectedRoleName }}
            </span>
          </div>
        </div>

        <div class="flex justify-end gap-3 pt-6 border-t border-gray-200 dark:border-gray-700">
          <app-button variant="outline" type="button" (btnClick)="cancel()">
            Cancelar
          </app-button>

          <!--
            Solo se bloquea mientras guarda, como el resto de formularios del CRM
            (ver contacto-form). Deshabilitarlo también con `form.invalid` dejaba el clic mudo:
            `save()` ya valida, marca los campos como tocados y avisa.
          -->
          <app-button
            type="submit"
            [disabled]="saving">
            {{ saving ? 'Guardando...' : (isEdit ? 'Actualizar' : 'Crear Usuario') }}
          </app-button>
        </div>

      </form>
    }
  </app-component-card>
</div>